import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import { ADMINISTRATIVE_CHECKLIST_PATH } from '../../../../config/paths';
import EnumStatus from '../../../common/EnumStatus';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { INCIDENT_RECORD_TYPE } from '../../../../config/constants';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import Content from '../../../layout/Content';
import { getItineraryIncidentById } from '../../../../actions/supervision-control/IncidentRecord';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

const AdministrativeCheckList = ({
  match: {
    params: { incidentRecordId },
  },
  dispatchGetItineraryIncidentById,
  breadcrumbs,
  loading,
  incidentRecord,
}) => {
  useLayoutEffect(() => {
    dispatchGetItineraryIncidentById({ incidentRecordId });
  }, []);

  const groupAnswersByTree = (answers) => {
    const trees = [];
    const roots = answers.filter((a) => a.parentId === null);

    roots.forEach((root) => {
      const children = answers.filter((a) => a.parentId === root.nodeId);
      trees.push({ root, children });
    });

    return trees;
  };

  let content = null;

  if (loading) {
    content = <Loader />;
  } else if (incidentRecord.isEmpty()) {
    content = <NoDataResource returnPage={ADMINISTRATIVE_CHECKLIST_PATH} />;
  } else {
    const incidentRecordJS = incidentRecord.toJS();
    const { answers, userFullName, incidentDate, incidentRecordType } =
      incidentRecordJS;

    const trees = groupAnswersByTree(answers);

    content = (
      <>
        <ResourceProperty label="Usuario:">{userFullName}</ResourceProperty>
        <ResourceProperty label="Tipo de Registro:">
          <EnumStatus
            enumValue={incidentRecordType}
            enumObject={INCIDENT_RECORD_TYPE}
          />
        </ResourceProperty>
        <ResourceProperty label="Fecha del Incidente:">
          {tzNormalizeDate({ date: incidentDate, format: DATE_TIME_FORMAT })}
        </ResourceProperty>

        <h4>Selecciones</h4>

        {trees.map(({ root, children }) => (
          <div key={root.nodeId} style={{ marginBottom: '1rem' }}>
            <ResourceProperty label={`${root.label}:`}>
              <ul style={{ marginBottom: 0 }}>
                {children.map((child) => (
                  <li key={child.nodeId}>{child.label}</li>
                ))}
              </ul>
            </ResourceProperty>

            {[root, ...children].map((answer) =>
              answer.note ? (
                <ResourceProperty
                  key={answer.nodeId}
                  label={`Nota (${answer.label}):`}
                >
                  {answer.note}
                </ResourceProperty>
              ) : null,
            )}
          </div>
        ))}
      </>
    );
  }

  return (
    <Content
      title="Detalle del Registro de Incidente"
      breadcrumbs={breadcrumbs}
      content={content}
    />
  );
};

AdministrativeCheckList.propTypes = {
  match: matchPropTypes.isRequired,
  dispatchGetItineraryIncidentById: PropTypes.func.isRequired,
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  loading: PropTypes.bool,
  incidentRecord: PropTypes.instanceOf(Immutable.Map),
};

AdministrativeCheckList.defaultProps = {
  loading: false,
  incidentRecord: Immutable.Map(),
};

const mapStateToProps = ({ SupervisionControlUnit }) => ({
  breadcrumbs: [
    ...SupervisionControlUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Checklist Administrativo',
      href: ADMINISTRATIVE_CHECKLIST_PATH,
    },
    {
      text: 'Incidente',
      href: '',
    },
  ],
  loading: SupervisionControlUnit.IncidentRecord.getIn([
    'incidentRecord',
    'loading',
  ]),
  incidentRecord: SupervisionControlUnit.IncidentRecord.getIn([
    'incidentRecord',
    'content',
  ]),
});

const mapDispatchToProps = {
  dispatchGetItineraryIncidentById: getItineraryIncidentById,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdministrativeCheckList);
